import React from 'react';

import data from '../../../../core/data';
import BlogWrapper from './BlogWrapper';

const Signature2012 = (props) => {
  return (
    <BlogWrapper heading={ data.news[5].heading } fluid >
      { data.news[5].body }
    </BlogWrapper>
  )
};

export default Signature2012;



/** WEBPACK FOOTER **
 ** ./src/components/containers/news/blogs/Signature2012.jsx
 **/